<template>
    <div v-if="dataLoaded">
        <p><a href="#" @click="goToUsersProfile()" class="mb-2"><i class="fa-regular fa-angle-left"></i> Back to User Profile</a></p>
        <b-card>
            <template v-slot:header>
                <span v-if="!editUser">
                    <b-form-select
                            @change="changeUser()"
                            v-model="userSelected"
                            :options="userOptions">
                    </b-form-select>
                </span>
                <span v-else>
                    <h5 class="mb-0">{{ user[0].name }}</h5>
                </span>

            </template>
            <b-row>

                <b-col>
                    <label>Role(s) Assigned</label>
                    <span v-if="gettingRolesByUser">
                        <div>
                            <i class="fa-regular fa-spinner fa-spin"></i>
                        </div>

                    </span>
                    <span v-else>
                        <template v-if="rolesByUser.length == 0">
                            <div>
                                <i>No roles assigned to this user</i>
                            </div>

                        </template>
                        <template v-else  v-for="(item,index) in rolesByUser">
                            <b-form-row class="mb-2">
                                <b-col>
                                    <b-card class="mb-0" body-class="py-1">
                                        <span class="font-weight-bold">{{ item.name }}</span>
                                    </b-card>
                                </b-col>
                                <b-col cols="2">
                                    <div class="d-flex h-100 align-items-center">
                                        <i class="h5 mb-0 fa-regular fa-times text-danger pointer" @click="deleteRoleFromUser(index)"></i>
                                    </div>
                                </b-col>
                            </b-form-row>
                        </template>
                    </span>



                </b-col>
                <b-col>
                    <label>Roles Available</label>
                    <b-form-select
                            :select-size="8"
                            v-model="roleSelected"
                            :options="roleOptions">
                    </b-form-select>
                </b-col>
            </b-row>
            <template v-slot:footer>
                <b-button @click="updateUsersRoles()" class="float-right" variant="success">
                    <span v-if="savingUsersRoles">
                        Saving <i class="fa-regular fa-spinner fa-spin"></i>
                    </span>
                    <span v-else>
                        Update Users Roles
                    </span>

                </b-button>
            </template>
        </b-card>


        <!-- Permissions Table -->
        <b-card>
            <template v-slot:header>
                <b-row>
                    <b-col>
                        Permissions Table
                    </b-col>
                    <b-col class="text-right">
                        <b-button v-if="!editPermissions"
                                  variant="secondary"
                                  @click="editPermissions = !editPermissions"
                                  class="float-right"
                                  size="sm">
                            <i class="fa-light fa-edit"></i>
                        </b-button>
                        <template v-if="editPermissions">
                            <b-button disabled size="sm" v-if="editPermissions" @click="openCreateNewRoleModal" variant="primary">Add Role <i class="ml-1 fa-regular fa-plus"></i></b-button>


                            <b-button class="mx-2" variant="success" size="sm" @click="savePermissionEdits">
                                <span v-if="savingRoles">
                                    Saving <i class="fa-solid fa-spinner fa-spin"></i>
                                </span>
                                <span v-else>
                                    Save Edits <i class="ml-1 fa-regular fa-save"></i>
                                </span>

                            </b-button>

                            <b-button size="sm" @click="cancelPermissionEdits">Cancel <i class="ml-1 fa-light fa-times"></i>
                            </b-button>
                        </template>
                    </b-col>
                </b-row>
            </template>

            <div @dblclick="!editPermissions ? editPermissions = true:'' ">
                <b-table responsive
                         sticky-header
                         bordered
                         v-if="dataLoaded"
                         :fields="permissionFields"
                         :items="roles">
                    <template v-slot:head()="data">
                        <div class="font-xs text-center">{{ data.label | titleCase }}</div>
                    </template>
                    <template v-slot:cell(role)="data">
                        <span class="">{{ data.item.name }}</span>
                    </template>
                    <template v-slot:cell()="data">
                        <template v-if="!editPermissions">
                            <div class="text-center align-columns-center" height="100%">
                                <i v-if="permissionByRole[data.item.name][(parseInt(data.field.id) - 1)].active && permissionByRole[data.item.name][(parseInt(data.field.id) - 1)].can_override"
                                   class="text-primary fa-regular fa-shield-check h4" style="color: #04a735!important;"></i>
                                <i v-else-if="permissionByRole[data.item.name][(parseInt(data.field.id) - 1)].active"
                                   class="text-primary fa-regular fa-check-square h4"></i>
                                <i v-else class="fa-light fa-square h4"></i>
                            </div>
                        </template>

                        <!--edit mode-->
                        <template v-else>
                            <div @mousedown="togglePermissionOnRole($event, data.field.id, data.item, data.index, data.index + '_' + data.field.id);" class="text-center">
                                <div :id="'field_values_' + data.index + '_' + data.field.id">
                                    <!-- <b-form-checkbox size="lg"
                                        @change="togglePermissionOnRole(data.field.id, data.item, data.index)"
                                        v-model="permissionByRole[data.item.name][(parseInt(data.field.id) - 1)].active">
                                    </b-form-checkbox> -->
                                    <i  v-if="permissionByRole[data.item.name][((data.field.id) - 1)].active && permissionByRole[data.item.name][((data.field.id) - 1)].can_override"
                                        class="text-primary fa-regular fa-shield-check h4" style="color: #04a735!important;;"></i>
                                    <i v-else-if="permissionByRole[data.item.name][((data.field.id) - 1)].active"
                                       class="text-primary fa-regular fa-check-square h4"></i>
                                    <i v-else class="fa-light fa-square h4"></i>
                                </div>
                            </div>
                            <b-popover ref="popover" :id="'click-control-' + data.index + '_' + data.field.id"
                                       triggers="blur"
                                       :target="'field_values_' + data.index + '_' + data.field.id">
                                <div class="">
                                    <b-list-group>
                                        <b-list-group-item href="#" @click="forcePermissionOnRole(data.field.id, data.item, data.index, data.index + '_' + data.field.id, 'disable');">
                                            <i class="fa-light fa-square h4 mr-2"></i>
                                            <span class="font-weight-bold">Remove permission</span></b-list-group-item>

                                        <b-list-group-item href="#" @click="forcePermissionOnRole(data.field.id, data.item, data.index, data.index + '_' + data.field.id, 'active');">
                                            <i class="text-primary fa-regular fa-check-square h4 mr-2"></i>
                                            <span class="font-weight-bold">Give Permission</span></b-list-group-item>

                                        <b-list-group-item href="#" @click="forcePermissionOnRole(data.field.id, data.item, data.index, data.index + '_' + data.field.id, 'override');">
                                            <i class="text-primary fa-regular fa-shield-check h4 mr-2" style="color: #04a735!important;"></i>
                                            <span class="font-weight-bold">Give Permission With Override</span></b-list-group-item>
                                    </b-list-group>
                                </div>
                            </b-popover>
                        </template>

                    </template>
                </b-table>
            </div>
        </b-card>


        <!--Add Role Modal-->
        <b-modal ref="modal-add-role" id="modal-add-role" title="Add Role">
            <b-container>
                <b-row>
                    <b-col class="text-center">
                        <p class="font-weight-bold">Name of the Role to add</p>
                        <b-input class="text-center" ref="add-role-name" v-model="roleToCreate"></b-input>
                    </b-col>
                </b-row>
            </b-container>
            <template #modal-footer="{}">
                <b-button size="sm" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="primary" size="sm" @click="createNewRole">
                    Add Role
                    <i v-if="addingRole" class="fa-regular fa-spin fa-spinner"></i>
                    <i v-else class="fa-regular fa-plus"></i>
                </b-button>
            </template>
        </b-modal>

        <FlagTypePermissions></FlagTypePermissions>
    </div>
</template>

<script>
    import FlagTypePermissions from "./FlagPermission";
    export default {
        name: 'settings-user-view',
        components: {FlagTypePermissions},
        data() {
            return {
                savingRoles: false,
                dataLoaded: false,
                savingUsersRoles:false,
                editPermissions: false,
                editUser: false,
                gettingRolesByUser: true,
                addingRole: false,
                id: this.$route.params.id,
                rolesByUser: [],
                rolesByUserCache: null,
                roleSelected:[],

                permissions: null,
                permissionFields: null,
                permissionByRole: {},

                users: null,
                user: null,
                userOptions: null,
                userSelected: null,

                roles: null,
                rolesCache: null,
                roleOptions: null,
                roleToCreate: null,
                rolesToSave: null,
            }
        },
        created() {
            window.addEventListener('contextmenu', function (e) {
                // do something here...
                e.preventDefault();
            }, false);
            this.getData();
//            this.id = parseInt(this.$route.params.id);
//            this.userSelected = parseInt(this.$route.params.id);
        },
        watch: {
            roleSelected(val) {
                let role = this.roles.filter(r => r.id === val);
                this.rolesByUser.push(role[0])
                this.disableUsedRoles();
            },
        },
        computed: {
        },
        methods: {
            rightClickHandler(e, row) {
                this.$root.$emit('bv::hide::popover');
                let popover = 'click-control-' + row;
                this.$root.$emit('bv::show::popover', popover);
            },

            goToUsersProfile() {
                this.$router.push('/settings/user/' +this.userSelected );
            },

            disableUsedRoles() {
                let that = this;
                this.rolesByUser.forEach(function (roleByUser) {
                    that.roleOptions.forEach( function (roleOption) {
                        if( roleByUser.id == roleOption.value) {
                            roleOption.disabled = true
                        }
                    })
                })
            },

            getRolesByUser() {
                this.gettingRolesByUser = true;
                let userId = this.userSelected;
//                let userId = this.$route.params.id;
                let arr = [];
                this.roles.forEach( function (role) {
                    if(role.users.data.length > 0) {
                        role.users.data.forEach( function (user) {
                            if(user.id == userId) {
                                arr.push(role);
                            }
                        })
                    }
                })
                this.rolesByUser = arr;
                this.rolesByUserCache = JSON.parse(JSON.stringify(this.rolesByUser));;
                this.gettingRolesByUser = false;
            },

            updateUsersRoles() {
                this.savingUsersRoles = true;
                let user = this.userSelected;
                let arr = this.rolesByUser.map(role => role.name);
                let payload = {roles: arr };
                this.$http.put('/users/'+ user + '/roles', payload).then(response => {
                    this.savingUsersRoles = false;
            });
            },

            disableRoleInSelectDropdown() {
                if( this.rolesByUser.some(item => this.roleOptions.includes(item)) ) {
                }
            },
            deleteRoleFromUser(index) {
                this.rolesByUser.splice(index, 1);
            },
            changeUser() {
                this.gettingRolesByUser = true;
                this.rolesByUser = [];
                this.$http.get('/roles').then(response => {
                    this.roles = response.data.data;
                this.getRolesByUser();
            });

            },








            // create group of roles with all permissions attached
            // this is used to bind all the permissions during editing
            createPermissionsByRole() {
                let that = this;
                this.roles.forEach( function (role) {
                    that.permissionByRole[role.name] = [];
                    that.permissions.forEach( function (permission) {
                        that.permissionByRole[role.name].push({
                            id:permission.id,
                            name:permission.name,
                            active: false,
                            can_override: false,
                        })
                    });
                    role.permissions.data.forEach( function (perm) {
                        let item = that.permissionByRole[role.name].find(x => x.id === perm.id)
                        if(item) {
                            item.active = true;
                            item.can_override = perm.can_override;
                        }
                    })
                })
            },
            //togglePermissionOnRole(data.field.id, data.item, data.index);
            togglePermissionOnRole(event, fieldKey, role, roleIndex, id) {
                event.preventDefault();
                if(event.button == 0) {
                    this.permissionByRole[role.name][(parseInt(fieldKey) - 1)].active =
                            !this.permissionByRole[role.name][(parseInt(fieldKey) - 1)].active;

                    let permission = this.permissionByRole[role.name][(parseInt(fieldKey) - 1)];

                    if (permission.active) {
                        this.roles[roleIndex].permissions.data.push({name: permission.name, can_override: false});
                    } else {
                        let index = this.roles[roleIndex].permissions.data.findIndex((el) => el.id == permission.id);
                        this.permissionByRole[role.name][(parseInt(fieldKey) - 1)].can_override = false;
                        this.roles[roleIndex].permissions.data.splice(index, 1);
                    }
                    this.permissionByRole = Object.assign({}, this.permissionByRole);
                    this.$forceUpdate();
                } else if(event.button == 2) {
                    //it won't rerender otherwise
                    this.rightClickHandler(event,id);
                    return false;
                }
            },
            forcePermissionOnRole(fieldKey, role, roleIndex, id, action) {
                let permission = this.permissionByRole[role.name][(parseInt(fieldKey) - 1)];
                let index = this.roles[roleIndex].permissions.data.findIndex((el) => el.id == permission.id);
                switch(action) {
                    case 'active':
                        this.permissionByRole[role.name][(parseInt(fieldKey) - 1)].active = true;
                        this.permissionByRole[role.name][(parseInt(fieldKey) - 1)].can_override = false;
                        if(index == -1) {
                            this.roles[roleIndex].permissions.data.push({name:permission.name, can_override: 0})
                        } else {
                            this.roles[roleIndex].permissions.data[index].can_override = 0;
                        }
                        break;
                    case 'override':
                        this.permissionByRole[role.name][(parseInt(fieldKey) - 1)].active = true;
                        this.permissionByRole[role.name][(parseInt(fieldKey) - 1)].can_override = true;
                        if(index == -1) {
                            this.roles[roleIndex].permissions.data.push({name:permission.name, can_override: 1});
                        } else {
                            this.roles[roleIndex].permissions.data[index].can_override = 1;
                        }
                        break;
                    case 'disable':
                        this.permissionByRole[role.name][(parseInt(fieldKey) - 1)].active = false;
                        this.permissionByRole[role.name][(parseInt(fieldKey) - 1)].can_override = false;
                        if(index != -1) {
                            this.permissionByRole[role.name][(parseInt(fieldKey) - 1)].can_override = false;
                            this.roles[roleIndex].permissions.data.splice(index, 1);
                        }
                        break;
                }
                //it won't rerender otherwise
                this.$root.$emit('bv::hide::popover');
                this.permissionByRole = Object.assign({}, this.permissionByRole);
                this.$forceUpdate();
            },

            cancelPermissionEdits() {
                this.roles = JSON.parse(JSON.stringify(this.rolesCache));
                this.createPermissionsByRole();
                this.editPermissions = false;
            },

            savePermissionEdits() {
                this.savingRoles = true;
                let roleID;
                let permissions;
                let that = this;
                let allPayloads = [];
                let promises = [];
                this.roles.forEach( function (role) {
                    roleID = role.id;
                    permissions = role.permissions.data.map( permission =>{return {"name": permission.name, "can_override": permission.can_override || 0 }});
                    let payload = {permissions: permissions};
                    allPayloads.push({
                        payload: payload,
                        roleId: role.id,
                    });
                });
                allPayloads.forEach( function (item) {
                    promises.push(
                            that.$http.put('/roles/'+ item.roleId +'/permissions', item.payload).then(response => {
                            })
                    );
                });
                Promise.all(promises).then(() => {
                    that.savingRoles = false;
                that.editPermissions = false;
                that.rolesCache = JSON.parse(JSON.stringify(this.roles));
            });
            },

            openCreateNewRoleModal() {
                this.$refs['modal-add-role'].show();
                let that = this;
                this.$root.$on('bv::modal::shown', function() {
                    this.$nextTick(function () {
                        that.$refs['add-role-name'].focus();
                    });
                });

            },
            createNewRole() {
                this.addingRole = true;
                let payload = {
                    id: this.test.roles.length + 1,
                    name: this.roleToCreate,
                    users: [],
                    permissions: [],
                };
                this.roles.push(payload);
                this.createPermissionsByRole();
                this.$nextTick(function () {
                    this.$refs['modal-add-role'].hide();
                    this.addingRole = false;
                    this.roleToCreate = null;
                });
            },



            // api calls to get page data
            getData() {



                let that = this;
                this.$http.all([
                    this.$http.get('/users'),
                    this.$http.get('/permissions'),
                    this.$http.get('/roles'),
                ]).then(this.$http.spread(function (usersResponse, permissionsResponse, rolesResponse) {
                    that.users = usersResponse.data.data;
                    that.permissions = permissionsResponse.data.data;
                    that.roles = rolesResponse.data.data;
                    that.rolesCache = JSON.parse(JSON.stringify(that.roles));
                    that.userOptions = that.users.map( user => ({value: user.id, text: user.name }) )
                    that.userOptions.unshift( { 'value': null, 'text': 'Select User', 'disabled': true} );
                    that.roleOptions = that.roles.map(item => ({value:item.id, text: item.name,}));
                    that.permissionFields = that.permissions.map(item =>({key: item.name.replace(/ /g, '_'),label: item.name, id: item.id}));

                    that.$nextTick(() => {
                        if(window.location.href.includes('?')) {
                            let queryString = window.location.search;
                            let urlParams = new URLSearchParams(queryString);
                            let id = urlParams.get('id');
                            that.id = id;

                            that.userSelected = that.userOptions.find(user => user.value == that.id).value;
                            that.getRolesByUser();
                            that.user = that.users.filter(u => u.id == parseInt(that.id));
                        }
                        that.permissionFields.unshift({key: 'role', label: '', stickyColumn: true});
                        that.createPermissionsByRole();
                        that.dataLoaded = true;
                    });
                }))
            },
        }
    };
</script>

<style scoped>

    .b-table-sticky-header {
        max-height: 700px !important;
    }
    .custom-control-input:checked ~
    .custom-control-label::before {
        border-color: green;
        background-color: green;
    }
    .align-columns-center {
        vertical-align: center;
    }
</style>

